// Redemptions that ask for more than the member has.
//
// A REDEMPTION IS A POSITIVE VALUE HERE. This reads the cashier FORM, where 折抵
// 3 means "redeem 3" -- the flip to the stored signed delta happens later, in
// awardValues. A negative is refused outright by the field's own validator, so
// anything reaching here is a redemption with a balance to exceed.
//
// THE BALANCE IS LOOKED UP BY VENDOR, not taken from the first row: a consumer
// resolved on two platforms would otherwise be checked against the wrong one's
// balance. The vendor is the section's, the same one its 折抵 boxes belong to.
//
// IT ONLY REPORTS. Two reasons it must never be turned into a validator:
//
//   * the balance is a snapshot taken when the phone was typed, and the same
//     customer may have spent it online since. Being out of date is normal.
//   * a coact validator that returns a message aborts the save (saga/editSaga),
//     so it would block the sale outright -- and the sale is the transaction,
//     not the points.
//
// So the staff is told and then decides. An unknown balance says nothing at all:
// null means the platform never answered, which is no grounds to warn on every
// sale during an outage.

import { balanceOf } from './memberBalance.js'

// Deliberately not ramda's R.path: this file is compiled into the client bundle.
const at = (doc, path) =>
  path.reduce(
    (node, key) =>
      node === null || node === undefined ? undefined : node[key],
    doc,
  )

const isBlank = value => value === null || value === undefined || value === ''

// The one vendor there is. A second gets its own section and its own checks.
const SHOPLINE = 'shopline'

const CHECKS = [
  {
    value: ['spendPoints', 'value'],
    vendor: SHOPLINE,
    field: 'points',
    label: '折抵點數',
    unit: '點',
  },
  {
    value: ['spendCredits', 'value'],
    vendor: SHOPLINE,
    field: 'credits',
    label: '折抵購物金',
    unit: '元',
  },
]

// [] when there is nothing to say, which is the common case and the one the
// caller should be cheapest to write against.
export default function overspend(doc) {
  return CHECKS.reduce((found, check) => {
    const wanted = Number(at(doc, check.value))

    // Zero and negative are both "not a redemption".
    if (!Number.isFinite(wanted) || wanted <= 0) return found

    const rawBalance = balanceOf(doc, check.vendor, check.field)
    if (isBlank(rawBalance)) return found

    const balance = Number(rawBalance)
    if (!Number.isFinite(balance)) return found

    if (wanted <= balance) return found

    return found.concat({
      label: check.label,
      unit: check.unit,
      wanted,
      balance,
    })
  }, [])
}

export { CHECKS }
